import { Slide, ToastContainer, ToastContainerProps } from 'react-toastify';

import { EToastContainerIds } from './toast.types';

import 'react-toastify/dist/ReactToastify.css';
import './toast.css';

const Toast = (props: ToastContainerProps) => {
  const { transition = Slide, ...rest } = props;
  return (
    <>
      <ToastContainer {...rest} transition={transition} />
      <ToastContainer containerId={EToastContainerIds.stacked} stacked {...rest} transition={transition} />
    </>
  );
};

export default Toast;
